export const BOOKINGRECIPIENT_SELF = "SELF";
export const BOOKINGRECIPIENT_OTHER = "OTHERS";
export const BOOKINGRECIPIENT_SELF_AND_OTHERS = "SELF_AND_OTHERS";

export const STEP_RECIPIENT = '/createbooking/recipient';
export const STEP_LOCATION = '/createbooking/location';
export const STEP_SERVICE_CATEGORIES = '/createbooking/servicecategories';
export const STEP_SERVICE_PACKAGES = '/createbooking/servicepackages';
export const STEP_SERVICE_DETAILS = '/createbooking/servicedetails';
export const STEP_SERVICE_COST = '/createbooking/servicecost';
export const STEP_SERVICE_BREAKDOWN = '/createbooking/servicebreakdown';
export const STEP_SCHEDULE = '/createbooking/schedule';
export const STEP_CREATE_ACCOUNT = '/createbooking/account/emailpassword';
export const STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION = '/createbooking/account/otp';
export const STEP_CREATE_ACCOUNT_VERIFY_MOBILE = '/createbooking/account/verify';
export const STEP_SIGN_IN = '/createbooking/account/signin';
export const STEP_PERSONAL_DETAILS = '/createbooking/personaldetails';
export const STEP_LIST_RECIPIENTS = '/createbooking/listrecipients';
export const STEP_BOOKING_ADDITIONAL_QUESTIONS = '/createbooking/additions';
export const STEP_PAYMENT = '/createbooking/payment';
export const STEP_POST_PAYMENT = '/createbooking/postpayment';

export const STEP_BOOKING_LIST = '/createbooking/bookings';

export const STEP_LINK_GENERATOR = '/createbooking/linkgenerator';

export const START_STEP = STEP_SERVICE_PACKAGES

const STEPARRAY = [
  {
    label: 'Select Recipient',
    visible: false,
    sidebar: false,
    value: STEP_RECIPIENT,
  },
  {
    label: 'Create Account',
    visible: false,
    sidebar: false,
    hideOnValidate: true,
    createAccountOnly: true,
    value: STEP_CREATE_ACCOUNT,
    order: 4
  },
  {
    label: 'Sign in',
    visible: false,
    sidebar: true,
    hideOnValidate: true,
    hideIfCreateAccount: true,
    value: STEP_SIGN_IN,
    order: 5
  },
  {
    label: 'Request Verification',
    visible: false,
    sidebar: false,
    hideOnValidate: true,
    createAccountOnly: true,
    value: STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION,
    order: 6
  },
  {
    label: 'Verify Mobile',
    visible: false,
    sidebar: false,
    hideOnValidate: true,
    createAccountOnly: true,
    value: STEP_CREATE_ACCOUNT_VERIFY_MOBILE,
    order: 7
  },

  {
    label: 'Service Categories',
    visible: false,
    sidebar: false,
    value: STEP_SERVICE_CATEGORIES
  },
  {
    label: 'Services',
    visible: true,
    sidebar: true,
    overrideWith: true,
    value: STEP_SERVICE_PACKAGES,
    order: 1
  },

  {
    label: 'Location',
    visible: true,
    sidebar: true,
    value: STEP_LOCATION,
    order: 9
  },

  {
    label: 'Tests',
    visible: false,
    sidebar: false,
    overrideWith: true,
    value: STEP_SERVICE_DETAILS,
    order: 2
  },
  {
    label: 'Service Cost',
    visible: false,
    sidebar: false,
    value: STEP_SERVICE_COST
  },
  {
    label: 'Breakdown',
    visible: true,
    sidebar: true,
    value: STEP_SERVICE_BREAKDOWN,
    order: 3,
  },
  {
    label: 'Schedule',
    visible: true,
    sidebar: true,
    value: STEP_SCHEDULE,
    order: 10
  },
  {
    label: 'Personal Details',
    visible: true,
    sidebar: true,
    value: STEP_PERSONAL_DETAILS,
    order: 8
  },
  {
    label: 'Additional Recipients',
    visible: false,
    sidebar: false,
    value: STEP_LIST_RECIPIENTS
  },
  {
    label: 'Booking Options',
    visible: true,
    sidebar: false,
    value: STEP_BOOKING_ADDITIONAL_QUESTIONS
  },
  {
    label: 'Payment',
    visible: true,
    sidebar: true,
    value: STEP_PAYMENT,
    order: 11
  },
  {
    label: 'Booking',
    visible: true,
    sidebar: true,
    value: STEP_POST_PAYMENT,
    order: 12
  },
]
export const CREATEACCOUNTCHAINSTEPS = [
  STEP_CREATE_ACCOUNT,
  STEP_CREATE_ACCOUNT_REQUEST_VERIFICATION,
  STEP_CREATE_ACCOUNT_VERIFY_MOBILE,
]

export const STANDALONE_STEPS = [
  STEP_LINK_GENERATOR,
  STEP_BOOKING_LIST
]

export const STEP_CART_ENABLED = [
  STEP_SERVICE_PACKAGES,
  STEP_SERVICE_DETAILS,
  STEP_SERVICE_COST,
]

export const STEP_LOCATION_SELECTOR_ENABLED = [
  STEP_SERVICE_PACKAGES,
  STEP_SERVICE_DETAILS,
]

export const VALID_STEPS = STEPARRAY.map((step) => step.value);

export const BREADCRUMBS = STEPARRAY.map(step=>{
  return {
    ...step,
    order: step.order || Number.MAX_SAFE_INTEGER
  }
}).sort((a, b) => {
  return a.order - b.order;
})